export default{
    formatDate(val){
        if(val){
            const arr = [val.slice(0,4),val.slice(4,6),val.slice(6,8)];
            return arr.join('-')
        }
    },
    formatState(val,role){
        if(role=='01'){
            if(val=='4')return '开立待经办修改';
            if(val=='2')return '开立待复核';
            if(val=='3'||val=='5'||val=='8')return '审核中';
            if(val=='7'||val=='C'||val=='9')return '待接收';
            if(val=='K'||val=='J'||val=='6'||val=='A'||val=='M'||val=='N')return '已废弃';
            if(val=='B')return '已接收';
        }else if(role=='02'){
            if(val=='7'||val=='F')return '接收待经办';
            if(val=='C'||val=='H')return '接收待经办修改';
            if(val=='9'||val=='G')return '接收待复核';
            if(val=='K'||val=='J'||val=='6'||val=='A'||val=='L'||val=='M'||val=='N')return '已废弃';
            if(val=='B')return '已接收';
        }else if(role=='03'){
            if(val=='E')return '流转待经办修改';
            if(val=='D')return '流转待复核';
            if(val=='F'||val=='H'||val=='G')return '待接收';
            if(val=='K'||val=='L'||val=='M'||val=='N')return '已废弃';
            if(val=='B')return '可流转';
        }else if(role=='04'){
            if(val=='3')return '（开立审核）待经办';
            if(val=='5')return '（开立审核）待复核';
            if(val=='7'||val=='C'||val=='9')return '待接收';
            if(val=='K'||val=='J'||val=='6'||val=='A'||val=='M'||val=='N')return '已废弃';
            if(val=='B')return '已接收';
        }
    },
    //格式化日期
    datePlugs(){
        Date.prototype.Format =function(fmt){
            let o = {
                "M+": this.getMonth() + 1,
                "d+": this.getDate(),
                "h+": this.getHours(),
                "m+":this.getMinutes(),
                "s+":this.getSeconds(),
                "q+":Math.floor((this.getMonth() +3) / 3),//季度
                "S": this.getMilliseconds() //毫秒
             };
             if(/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4-RegExp.$1.length));
             for(let k in o)
                if(new RegExp("("+k+")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length ===1)?(o[k]):(("00"+o[k]).substr((""+o[k]).length)));
            return fmt;
        }
    },
    initDate(v){//格式化日期
        if(!v)return;
        let d = new Date(v);
        let year = d.getFullYear();
        let month = d.getMonth()+1;
        month = month < 10 ? '0' + month : month;
        let dt = d.getDate();
        dt = dt < 10 ? '0' + dt : dt;
        let today = year+''+month+''+dt;
        return today;
    },
    //金额千分位保留两位小数
    'filterAll':function(val){
        if(typeof(val)==='number'){
            return (val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,'$1,')
        }
    },
    //格式化金额
    formatMoney(money){
        if(money && money != null){
            money = String(money);
            var left = money.split('.')[0],right = money.split('.')[1];
            right = right ? (right.length >= 2 ? '.' + right.substr(0,2) : '.' + right + '0') : '.00';
            var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
            return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
        }else if (money === 0){//注意===在这里的使用，如果传入的money为0，if中会将其判断为boolean类型，故而要另外做===判断
            return '0.00';
        }else {
            return '';
        }
    },
    //格式化金额（基础资产弹窗李合同金额专用）
    formatMoneyContAmt(money){
        if(money && money != null && money !== "0" && money !== 0){
            money = String(money);
            var left = money.split('.')[0],right = money.split('.')[1];
            right = right ? (right.length >= 2 ? '.' + right.substr(0,2) : '.' + right + '0') : '.00';
            var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
            return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right;
        }else {
            return '';
        }
    }
}
    


// WEBPACK FOOTER //
// ./src/libs/filter.js